import React from 'react'
import { useTranslation } from 'react-i18next'
import PlaceholderPage from '../PlaceholderPage'

function ErrorPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('error') || 'Error'} />
}

export default ErrorPage
